import { createContext } from 'react';
const VideoErrorLogContext = createContext();
export default VideoErrorLogContext;
